export const language = {
  defaultLoadingDataErrorMessage: 'خطا در بارگذاری اطلاعات',
  defaultUpdateButtonText: 'بروزرسانی',
};
